module.exports = __webpack_public_path__ + "static/img/referrer.ef0f491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/referrer.png
// module id = VlzH
// module chunks = 1